import * as React from "react"
import "./index.less"

interface IProps {
  message: string
}

const handleRetry = () => {
  const url = new URL(window.location.href)
  url.searchParams.set("_v", String(Date.now()))
  window.location.href = url.toString()
}

const BootError: React.FC<IProps> = ({ message }) => (
  <div className="boot-error">
    <h1 className="boot-error__title">Không thể khởi tạo ứng dụng</h1>
    <p className="boot-error__message">
      Không tải được cấu hình hệ thống. Vui lòng thử lại. ({message})
    </p>
    <button type="button" className="boot-error__retry" onClick={handleRetry}>
      Thử lại
    </button>
  </div>
)

export default BootError
